import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService, UserIdService, TranslatePipe } from '@spartacus/core';
import { Order } from '@spartacus/order/root';
import { ICON_TYPE, LaunchDialogService, SpinnerComponent, IconComponent } from '@spartacus/storefront';
import { BehaviorSubject, merge, take } from 'rxjs';
import { resendEmailMainPayload, resendEmailOrderPayload } from 'src/app/udxb2b/features/model';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-resend-email-popup',
    templateUrl: './resend-email-popup.component.html',
    styleUrl: './resend-email-popup.component.scss',
    imports: [SpinnerComponent, IconComponent, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDividerModule, AsyncPipe, TranslatePipe]
})
export class UDXResendEmailPopupComponent implements OnInit {

  launchDialogService = inject(LaunchDialogService);
  mailSent$ = new BehaviorSubject<boolean>(false);
  iconTypes = ICON_TYPE;
  userId: string = '';
  httpClient = inject(HttpClient);
  userIdService = inject(UserIdService);
  occEndPoint = inject(OccEndpointsService);
  order: Order | undefined;
  orderPayload: resendEmailOrderPayload[] = []
  globalMessageService = inject(GlobalMessageService);
  errorMessage = signal('');

  private formBuilder = inject(FormBuilder);
  emailGroup = this.formBuilder.group({
    existingEmailID: ['',],
    resendEmailID: new FormControl ('',[Validators.required, Validators.email]),

  });
  constructor() {
    merge( this.emailGroup.controls.resendEmailID?.valueChanges,this.emailGroup.controls.resendEmailID?.statusChanges)
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.updateErrorMessage());
  }

  ngOnInit(): void {
    this.launchDialogService.data$
    .pipe(take(1))
    .subscribe((data: any) => {
      // console.log('data is ', data);
      this.order = data;
      this.emailGroup.get('existingEmailID')?.setValue(data?.emailId);
      // Disable the existingEmailID form control to prevent user input
      this.emailGroup.get('existingEmailID')?.disable();
      // Set the value of resendEmailID to the existing email ID
      this.emailGroup.get('resendEmailID')?.patchValue(data?.emailId);

    }
    )
  }
  dismissModal(reason?: any): void {
    this.launchDialogService.closeDialog(reason);
  }
  updateErrorMessage() {
    if (this.emailGroup.get('resendEmailID')?.hasError('required')) {
      this.errorMessage.set('You must enter a value');
    } else if (this.emailGroup.get('resendEmailID')?.hasError('email')) {
      this.errorMessage.set('Not a valid email');
    } else {
      this.errorMessage.set('');
    }
  }
  sendEmail(): void {
    let subPayload: resendEmailOrderPayload;
    if (this.emailGroup.valid) {
      this.mailSent$.next(true);
      // build url
      let userId = '';
      this.userIdService.getUserId()
      .pipe(take(1))
      .subscribe((e: any) => {
        if (e) {
          userId = e;
        }
      });
      const url = this.occEndPoint.buildUrl('resendEmail', {
        urlParams: {
          userId: userId,
        },
      })

      // build body
      let orderType = this.order?.orderType!;
      this.order?.linkedOrders.filter(order => {
        if ((order?.status === 'CONFIRMED' && orderType != "Exchange_Order") || (order?.status === 'EXCHANGED')) {
          return true;
        }
        return false;
      }).forEach(order => {
        subPayload = {
          code: order?.code,
          orderType: order?.orderType,
          status: order?.status
        }
        this.orderPayload.push(subPayload);
      })
      const body: resendEmailMainPayload = {
        resendEmail: this.emailGroup.get('resendEmailID')?.value ?? '',
        orderType: orderType,
        orders: this.orderPayload
      };
      this.httpClient.post(url, body)
      .pipe(take(1))
      .subscribe(
        {
          next: (res) => {
            console.error('Email sent successfully:', res);
            this.mailSent$.next(false);
            this.dismissModal("mail sent successfully");
            this.globalMessageService.add({ key: 'orderDetails.mailSentSuccess' }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
            // setTimeout(() => {
            //   window.location.href = window.location.href;
            // }, 5000);
          },
          error: (err) => {
            console.error('Error sending email:', err);
            this.mailSent$.next(false);
            this.dismissModal("mail send error");
            this.globalMessageService.add({ key: 'orderDetails.mailSentFailure' }, GlobalMessageType.MSG_TYPE_ERROR);
            // setTimeout(() => {
            //   window.location.href = window.location.href;
            // }, 5000);
          }
        }
      )
    }
  }
}
